export const testConfig = {
  topic: "Test",
  sdkKey: "pSF15qTjRxSbuvu7rbyG_g",
  role: 0,
  meetingNumber: 8173462034,
  password: "406891",
};
